





import { Vue, Component } from 'vue-property-decorator';

@Component
export default class XSolid extends Vue {}
